import React from 'react';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { Table, TableCell, TableHead, TableHeader, TableRow } from 'src/domains/common/components/table/table';
import { DateTime } from 'src_common/utils/time/time';
import { CustomerButton } from 'src/components/FraudAndCompliance/CustomerButton/CustomerButton';
import { MatchedExclusionsTooltip } from './MatchedExclusionsTooltip/MatchedExclusionsTooltip';
import { StyledTableBody } from './MatchedExclusionsTable.style';

export interface OnMatchRowType {
    accountId: number;
    universe: string;
    dateOfSelfExcluded: string | undefined;
    selfExclusionStatus: string;
    firstName: string;
    surname: string;
    accountStatus: string;
}

interface MatchedExclusionsTableType {
    isLoading: boolean;
    rows: OnMatchRowType[];
}

const formatDate = (value: string | undefined): string => {
    if (value === undefined) {
        return '-';
    }
    return DateTime.fromUTC(value)?.format('DD/MM/YYYY') ?? '-';
};

export const MatchedExclusionsTable: React.FC<MatchedExclusionsTableType> = ({ isLoading, rows }) => {
    if (isLoading) {
        return (
            <LoadingV2
                dataTest='on-match-exclusions-loading'
                title='Loading matched exclusions...'
            />
        );
    }

    if (rows.length === 0) {
        return <p data-test='on-match-exclusions-empty'>No matched exclusions found.</p>;
    }

    return (
        <div data-test='on-match-exclusions-table'>
            <h3 className='text-foreground mb-2 flex items-center gap-1'>
                Matched Exclusions
                <MatchedExclusionsTooltip />
            </h3>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Date of Self Excluded</TableHead>
                        <TableHead>Customer Details</TableHead>
                        <TableHead>Self exclusion status</TableHead>
                        <TableHead>Account Status</TableHead>
                    </TableRow>
                </TableHeader>
                <StyledTableBody>
                    {rows.map((row, index) => (
                        <TableRow key={`${row.accountId}-${row.universe}-${index}`}>
                            <TableCell>{formatDate(row.dateOfSelfExcluded)}</TableCell>
                            <TableCell>
                                <CustomerButton
                                    customerId={row.accountId}
                                    firstName={row.firstName}
                                    surname={row.surname}
                                />
                            </TableCell>
                            <TableCell>{row.selfExclusionStatus}</TableCell>
                            <TableCell>{row.accountStatus === '' ? '-' : row.accountStatus}</TableCell>
                        </TableRow>
                    ))}
                </StyledTableBody>
            </Table>
        </div>
    );
};
